import React,  { lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';
import SearchBarSS from '../SearchBar/SearchBarSS';
import DashboardTab from '../DashBoard/DashBoardTab';
import AuthSettings from '../Auth/AuthSettings';
import WhatsAppIcon from '../Social/WhatsAppIcon';
import Loader from '../Loader/Waiting';
import ResultSearch from './ResultSearch';
// import SearchFilterModal from './SearchPickModal';
import SearchFilterModal from '../SearchPage/Slider/FilterModal';
import OtherServiceChannels from '../Modal/OtherService';
import AdsModal from '../Modal/AdsModal';


const SmallScreenSearch = lazy(() => import('../SearchBar/SmallScreenSearch'));
const ShopAll = lazy(() => import('../DropDown/ShopAll'));
const ModalMenu = lazy(() => import('../Modal/ModalMenu'));
const SearchBarBS = lazy(() => import('../SearchBar/SearchBarBS'));
const OnDemand = lazy(() => import('../DropDown/OnDemand'));
const Recommended = lazy(() => import('../DropDown/Recommended'));
const OurLocations = lazy(() => import('../DropDown/Ourlocations'));
const ContactUs = lazy(() => import('../Contact/ContactUs'));
const Footer = lazy(() => import('../Footer/Footer'));
const Waiting = lazy(() => import('../Loader/Waiting'));
const ProductModal = lazy(() => import('../SearchPage/ProductModal'));

const SearchPage = () => {
  const { selectedListing } = useSelector(state => state.filterSearch);
  return (
    <div className='search-dashboard'>
      <Suspense fallback={<Loader/>}>
        <ModalMenu />
        <OtherServiceChannels />
        <SmallScreenSearch />
        <SearchBarBS />
        <SearchBarSS />
        <Waiting />
      </Suspense>
      <Suspense fallback={<Loader />}>
        <ProductModal />
      </Suspense>
      <DashboardTab />
      <AuthSettings />
      <WhatsAppIcon />
      <SearchFilterModal />
      <AdsModal /> 
      <Suspense fallback={<Loader/>}>
        <ShopAll />
        <OnDemand />
        <Recommended />
        <OurLocations />
        <ContactUs />
      </Suspense>
      <ResultSearch />
      <Suspense fallback={<Loader/>}>
        <Footer />
      </Suspense>
    </div>
  )
};

export default SearchPage;
